const runtimeConfig =
  typeof window !== "undefined" && window.__TELIVI_RUNTIME_CONFIG__
    ? window.__TELIVI_RUNTIME_CONFIG__
    : {};

export const getConfigValue = (key, buildTimeValue, defaultValue = "") => {
  const runtimeValue = runtimeConfig[key];
  if (typeof runtimeValue === "string" && runtimeValue.trim()) {
    return runtimeValue.trim();
  }
  if (typeof buildTimeValue === "string" && buildTimeValue.trim()) {
    return buildTimeValue.trim();
  }
  return defaultValue;
};

export default runtimeConfig;
